module.exports = __webpack_public_path__ + "img/banner-3.720d4465.jpg";